import { Contract } from 'shared/models/contract';
import { BadgeThemeKeys } from 'theme/components/Badge';

export interface ContractServiceBadgeProps {
  contract: Contract;
}

enum PlanBadgeVariant {
  DS_GREEN = BadgeThemeKeys.YOOGA_GREEN,
  DS_BLUE = BadgeThemeKeys.YOOGA_PRIMARY,
  DS_SECUNDARY = BadgeThemeKeys.YOOGA_SECONDARY,
  DS_YELLOW = BadgeThemeKeys.YOOGA_YELLOW,
  DS_GRAY = BadgeThemeKeys.YOOGA_GRAY,
  DS_ORANGE = BadgeThemeKeys.YOOGA_ORANGE,
}

interface BadgeRenderData {
  badgeVariant: PlanBadgeVariant;
  planName: string;
}

const badgeVariantMap: Record<string, PlanBadgeVariant> = {
  Completo: PlanBadgeVariant.DS_GREEN,
  'Clube Yooga': PlanBadgeVariant.DS_SECUNDARY,
  Essencial: PlanBadgeVariant.DS_BLUE,
  Básico: PlanBadgeVariant.DS_YELLOW,
  Autoatendimento: PlanBadgeVariant.DS_ORANGE,
};

export const getBadgeVariant = (contract: Contract): BadgeRenderData => {
  const planName = contract.planName ?? '';
  if (!contract.licensePlan) {
    return { badgeVariant: PlanBadgeVariant.DS_GRAY, planName };
  }
  const badgeVariant = badgeVariantMap[planName] ?? PlanBadgeVariant.DS_GRAY;
  return { badgeVariant, planName };
};

export const getBadgeVariantByName = (name: string): BadgeRenderData => {
  const planName = name.split(' - ')[0];
  const badgeVariant = badgeVariantMap[planName] ?? PlanBadgeVariant.DS_GRAY;
  return { badgeVariant, planName };
};
